import React from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Modal } from 'ksnm-common-ui/lib/Modal';
import type { ReactElement } from 'react';

import { confirmDialogStore } from '@stores/confirmDialog';

import styles from './ConfirmDialog.module.scss';

function ConfirmDialogComponent(): ReactElement {
  return (
    <Modal
      title={confirmDialogStore.title}
      open={confirmDialogStore.visible}
      className={styles.modal}
      wrapClassName={styles.wrap}
      centered
      footer={null}
      onCancel={confirmDialogStore.close}
      width={confirmDialogStore.width ?? 373}
      closeIcon={<Icon name="close" noFill />}
    >
      <div className={styles.text}>
        {confirmDialogStore.iconType && (
          <Icon
            name={confirmDialogStore.iconType}
            fill={confirmDialogStore.iconFill}
            className={styles.icon}
            height={40}
          />
        )}
        {confirmDialogStore.text}
      </div>

      <div className={styles.buttons}>
        <button className={styles.button} key="ok" onClick={confirmDialogStore.confirm}>
          Да
        </button>

        <button className={cm(styles.button, styles.cancel)} key="cancel" onClick={confirmDialogStore.cancel}>
          Нет
        </button>
      </div>
    </Modal>
  );
}

export const ConfirmDialog = observer(ConfirmDialogComponent);
